import React, { useState, useEffect } from "react";
import {
  useHistory,
  useParams,
  useRouteMatch,
} from "react-router-dom/cjs/react-router-dom";
import { message } from "antd";

import Header from "../../components/Header";
import {
  cadastrarGrupoDealer,
  alterarGrupoDealer,
  detalheGrupoDealer,
} from "../../services/http/cadastrosService";

import "../Usuario/styles.css";
import "./styles.css";

const FORM_INICIAL = {
  nome: "",
  status: "Ativo",
};

/** Cadastro/edição/visualização de grupo dealer (RD 95133). */
export default function GrupoDealerNovoEditar() {
  const history = useHistory();
  const { id } = useParams();
  const somenteLeitura = !!useRouteMatch(
    "/cadastros/grupos-dealer/visualizar/:id"
  );

  const [form, setForm] = useState(FORM_INICIAL);
  const [erros, setErros] = useState({});
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    if (!id) return;

    const carregar = async () => {
      const resposta = await detalheGrupoDealer(id);

      if (resposta.fail) {
        message.error(
          resposta.errors?.message || "Não foi possível carregar o grupo dealer"
        );
        return;
      }

      setForm({
        nome: resposta.data?.nome ?? "",
        status: resposta.data?.status ?? "Ativo",
      });
    };

    carregar();
  }, [id]);

  const alterarCampo = (evento) => {
    const { name, value } = evento.target;
    setForm((anterior) => ({ ...anterior, [name]: value }));
    setErros((anterior) => ({ ...anterior, [name]: undefined }));
  };

  const validar = () => {
    const novosErros = {};

    if (!form.nome.trim()) novosErros.nome = "Nome do grupo é obrigatório";

    setErros(novosErros);
    return Object.keys(novosErros).length === 0;
  };

  const enviar = async (evento) => {
    evento.preventDefault();

    if (!validar()) return;

    setSalvando(true);

    try {
      const payload = { nome: form.nome.trim(), status: form.status };

      const resposta = id
        ? await alterarGrupoDealer(id, payload)
        : await cadastrarGrupoDealer(payload);

      if (resposta.fail) {
        const mensagem =
          resposta.errors?.message || "Não foi possível salvar o grupo dealer";

        // O backend valida nome duplicado; mostra o erro no próprio campo.
        setErros((anterior) => ({ ...anterior, nome: mensagem }));
        message.error(mensagem);
        return;
      }

      message.success(
        id ? "Grupo dealer alterado com sucesso" : "Grupo dealer cadastrado com sucesso"
      );
      history.push("/cadastros/grupos-dealer");
    } finally {
      setSalvando(false);
    }
  };

  const titulo = somenteLeitura
    ? "Visualizar Grupo Dealer"
    : id
    ? "Editar Grupo Dealer"
    : "Novo Grupo Dealer";

  return (
    <>
      <Header style={{ marginBottom: "2rem" }} mostrarPesquisar={false} />

      <div className="container">
        <h1 className="title">{titulo}</h1>

        <form onSubmit={enviar} className="admin-form">
          <div className="form-section">
            <h2>Dados do Grupo</h2>

            <div className="row">
              <div className="col-md-6 col-lg-6 mb-3">
                <div className="form-group">
                  <label>
                    Nome do grupo <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    name="nome"
                    value={form.nome}
                    onChange={alterarCampo}
                    disabled={somenteLeitura}
                    maxLength={150}
                    placeholder="Ex.: Grupo Centro-Oeste"
                    className={`form-control ${erros.nome ? "is-invalid" : ""}`}
                  />
                  {erros.nome && (
                    <div className="invalid-feedback">{erros.nome}</div>
                  )}
                </div>
              </div>

              <div className="col-md-6 col-lg-3 mb-3">
                <div className="form-group">
                  <label>Status</label>
                  <select
                    name="status"
                    value={form.status}
                    onChange={alterarCampo}
                    disabled={somenteLeitura}
                    className="form-control"
                  >
                    <option value="Ativo">Ativo</option>
                    <option value="Inativo">Inativo</option>
                  </select>
                  <small className="form-text text-muted">
                    Só grupos ativos aparecem no cadastro de concessionária.
                  </small>
                </div>
              </div>
            </div>
          </div>

          <div className="form-actions">
            <button
              type="button"
              className="cancel-button"
              onClick={() => history.push("/cadastros/grupos-dealer")}
            >
              {somenteLeitura ? "Voltar" : "Cancelar"}
            </button>

            {!somenteLeitura && (
              <button type="submit" className="save-button" disabled={salvando}>
                {salvando ? "Salvando..." : "Salvar"}
              </button>
            )}
          </div>
        </form>
      </div>
    </>
  );
}
